import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { Button, Input, Radio, RadioGroup, Stack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
// import { createCurrentVoucherData } from '../../../Redux/Voucher/CurrentVoucherReducer'
import { useDispatch } from "react-redux";
import { message } from "antd";
import Select from "react-select";
import UploadImage from "./Upload";
import adScreen from "../../../../assets/usersDashboard/adScreen.svg";
import ReactDatePicker from "react-datepicker";
import { createPartnerAdData } from "../../../../Redux/Advertisement/Partner/PartnerAdReducer";
import { userRequest } from "../../../../requestMethod";

const initialState = {
  name: "",
  image: "",
  title: "",
  body: "",
  cities: [],
  releaseDate: "",
  adType: "Feed",
};

const cityOptions = [
  { value: "Berlin", label: "Berlin" },
  { value: "Paris", label: "Paris" },
  { value: "New York", label: "New York" },
];

const CreateAd = ({ setCreateAd }) => {
  const [selectedCities, setSelectedCities] = useState([]);
  const dispatch = useDispatch();
  const [fileList, setFileList] = useState([]);
  const [form, setForm] = useState(initialState);
  const [previewImage, setPreviewImage] = useState("");
  const [type, setType] = useState(initialState.adType);

  const handleImageUpload = (newFileList) => {
    if (newFileList.length > 0 && newFileList[0].status === "done") {
      setForm({ ...form, image: newFileList[0].response.url });
    }
  };

  const addData = () => {
    if (!form.name) {
      message.error("Enter Ad Name");
    } else if (!form.title) {
      message.error("Enter title");
    } else if (!form.body) {
      message.error("Enter body");
    } else if (!form.cities) {
      message.error("Enter cities");
    } else if (!form.releaseDate) {
      message.error("Enter releaseDate");
    } else {
      dispatch(createPartnerAdData(form))
        .then(() => {
          setForm(initialState);
          setPreviewImage("");
          setFileList([]);
          message.success("Advertisement created successfully");
        })
        .catch((error) => {
          message.error(`Error: ${error.message}`);
        });
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "70%",
      height: "75px", // Set the desired height for the entire select component
      borderRadius: "18px",
      alignItems: "center", // Center content vertically
      justifyContent: "center",
      display: "flex",
      border: "none",
      boxShadow: "none",
      backgroundColor: "#ecf1f4",
    }),
    menu: (provided) => ({
      ...provided,
      width: "70%",
      backgroundColor: "#ecf1f4",
      alignItems: "center",
      fontSize: "15px",
      // Center content vertically

      color: "black",
      zIndex: 2, // Ensure the menu appears above other elements
    }),
    option: (provided, state) => ({
      ...provided,
      minHeight: "60px", // Set the desired height for each option item
      display: "flex", // Use flex to vertically align content
      alignItems: "center", // Center content vertically
      backgroundColor: "#ecf1f4",
      color: "black",
      cursor: "pointer",
      fontSize: "15px",
      borderBottom: "1px solid white",
      textAlign: "center",
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the default arrow and line
    }),
  };

  const handleCityChange = (selectedOptions) => {
    setSelectedCities(selectedOptions);
    setForm({ ...form, cities: selectedCities })
  };

  return (
    <div className={styles.MainContainer}>
      <div className={styles.container1}>
        <span style={{ whiteSpace: "nowrap" }}>
          Partner Ads {">"}{" "}
          <b
            style={{ opacity: "100%", color: "#131313", whiteSpace: "nowrap" }}
          >
            Create an Advertisement
          </b>
        </span>
        <h1>Create an Ad</h1>

        <div className={styles.resetPassword}>
          <RadioGroup onChange={setType} value={type}>
            <Stack direction="column">
              <Radio value="Suggestion">
                <p className={styles.radioP}>Suggestion List (choose a city)</p>
              </Radio>
              <Radio value="Feed">
                <p className={styles.radioP}>
                  In-feed Ad (location-based + 10 Km radius)
                </p>
              </Radio>
            </Stack>
          </RadioGroup>

          <p>Ad Name*</p>
          <Input
            placeholder="Enter Ad Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <p>Ad title*</p>
          <Input
            placeholder="Ad Title (max. 50 characters)"
            maxLength={50}
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />

          <p>Ad Body*</p>
          <textarea
            placeholder="Ad Body (max. 150 characters)"
            maxLength={150}
            rows={4}
            value={form.body}
            onChange={(e) => setForm({ ...form, body: e.target.value })}
          />
          <UploadImage
            setFileList={setFileList}
            fileList={fileList}
            setPreviewImage={setPreviewImage}
            previewImage={previewImage}
            onImageUpload={handleImageUpload}
          />
          <p className={styles.longString}>
            Please verify that your uploaded file compiles with our system
            requirements for ads campaign
          </p>
          <div></div>
          <p>Only Received by users in the following city:</p>
          {/* <Input placeholder='City' value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} /> */}
          <Select
            isMulti
            styles={customStyles}
            options={cityOptions}
            value={selectedCities}
            onChange={handleCityChange}
            placeholder="City"
          />
          <p>Release on:</p>
          <ReactDatePicker
            selected={form.releaseDate}
            onChange={(e) => setForm({ ...form, releaseDate: e })}
            placeholderText="Release date"
          />
        </div>
      </div>
      <div className={styles.preview}>
        <div className={styles.btn}>
          <Button
            colorScheme="black"
            variant="outline"
            w="127px"
            onClick={() => setCreateAd(false)}
          >
            Cancel
          </Button>
          <Button
            bg="black"
            color="#fff"
            variant="solid"
            w="127px"
            onClick={addData}
          >
            Save
          </Button>
        </div>
        <div className={styles.previewInner}>
          <p>Preview of my profile</p>
          <div className={styles.screenDiv}>
            <div className={styles.screenDiv1}>
              <img
                className={styles.screenDiv1Img}
                src="https://dfstudio-d420.kxcdn.com/wordpress/wp-content/uploads/2019/06/digital_camera_photo-1080x675.jpg"
                alt=""
              />
              <span>
                <h2>{form.title}</h2>
                <pre>{form.body} </pre>
              </span>
            </div>
            <img src={adScreen} alt="" />
          </div>
          <p>
            Please note that it can take up to 24 hours for your ad to be <br />
            approved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreateAd;
